export const PAYMENT_CARD_SIZE_CLASS = 'w-[340px] aspect-[1.586]';
